import Vue from 'vue'

export default {
    updateContact(params) {
        return Vue.axios.post(`/pages/contact/update`, params)
    },
    getContact() {
        return Vue.axios.get(`/pages/contact`)
    },
    updateInfo(params) {
        return Vue.axios.post(`/pages/info/update`, params)
    },
    getInfo() {
        return Vue.axios.get(`/pages/info`)
    },
    updatePartnership(params) {
        return Vue.axios.post(`/pages/partnership/update`, params)
    },
    getPartnership() {
        return Vue.axios.get(`/pages/partnership`)
    },
    updatePaymentDelivery(params) {
        return Vue.axios.post(`/pages/payment-delivery/update`, params)
    },
    getPaymentDelivery() {
        return Vue.axios.get(`/pages/payment-delivery`)
    },
    getOfferPage(id){
        return Vue.axios.get(`/offer-pages/${id}`)
    },
    listOfferPage(){
        return Vue.axios.get(`/offer-pages`)
    },
    createOfferPage(params){
        return Vue.axios.post(`/offer-pages`, params)
    },
    updateOfferPage(id, params){
        return Vue.axios.post(`/offer-pages/${id}`, params)
    },
    removeOfferPage(id){
        return Vue.axios.delete(`/offer-pages/${id}`)
    },
    getFranchisePage(id){
        return Vue.axios.get(`/franchise-pages/${id}`)
    },
    listFranchisePage(){
        return Vue.axios.get(`/franchise-pages`)
    },
    createFranchisePage(params){
        return Vue.axios.post(`/franchise-pages`, params)
    },
    updateFranchisePage(id, params){
        return Vue.axios.post(`/franchise-pages/${id}`, params)
    },
    removeFranchisePage(id){
        return Vue.axios.delete(`/franchise-pages/${id}`)
    },
}
